<template>
  <div class="task-status-button" :class="['task-status-button--' + value]" v-bind="$attrs">
    <div class="task-status-button__dot"></div>
    <div class="task-status-button__label">{{ label }}</div>
  </div>
</template>

<script>
const statusLabels = {
  request: 'taskStatusRequest',
  done: 'taskStatusDone',
}

export default {
  props: {
    value: String,
  },
  computed: {
    label() {
      return this.$t(statusLabels[this.value] || this.value)
    },
  },
}
</script>

<style lang="scss">
.task-status-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8em;
  padding: 0.25rem 0.5rem;
  border: 1px solid currentColor;
  border-radius: var(--border-radius);
  cursor: pointer;
  max-width: min-content;

  &[readonly] {
    pointer-events: none;
  }

  &__dot {
    aspect-ratio: 1 / 1;
    height: 0.5rem;
    border-radius: 50%;
    background-color: currentColor;
  }

  $states: (
    request: 'primary',
    undone: 'warning',
    done: 'success',
    rejected: 'error',
  );

  @each $name, $key in $states {
    &--#{$name} {
      color: var(--#{$key});

      &:not([readonly]):hover {
        background-color: hsl(var(--#{$key}-h), var(--#{$key}-s), 97%) !important;
      }
    }
  }
}
</style>
